import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline, spotsTakenPercent } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/**
 * Urgency block that sits directly above the value stack.
 */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  return <div className="mx-auto max-w-xl rounded-4xl border border-flame/50 bg-flame px-6 py-7 text-center shadow-lift sm:px-9" data-id="element-27" data-mp="15dnwant2wd3w">
      <p className="flex items-center justify-center gap-2 font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-shell" data-id="element-28" data-mp="34r0d2l0qebn5">
        <AlarmClockIcon className="h-4 w-4 text-lime" strokeWidth={2.2} aria-hidden="true" data-id="element-29" data-mp="2zs714x13esp3" />
        The 95% launch price ends in:
      </p>

      {isExpired ? <p className="mt-4 font-display text-xl font-bold leading-snug text-shell" data-id="element-30" data-mp="1h0b2mqhrb1zj">
          Today’s launch price has ended.
        </p> : <>
          <div className="mt-5 flex items-center justify-center gap-2 sm:gap-3" aria-hidden="true" data-id="element-31" data-mp="124bvpj6dv7vz">
            {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-32" data-mp="1ur6du9fq9v6a" data-mpi={index}>
                <div className="flex min-w-[4.5rem] items-baseline justify-center gap-1 rounded-2xl bg-shell px-3 py-2.5 sm:min-w-[5.5rem]" data-id="element-33" data-mp="1ushh8859h0wv">
                  <span className="font-display text-3xl font-extrabold leading-none tabular-nums text-ink sm:text-4xl" data-id="element-34" data-mp="1zs3vmkwtsn79">
                    {pad(unit.value)}
                  </span>
                  <span className="font-sans text-[10px] font-semibold uppercase tracking-[0.1em] text-stone" data-id="element-35" data-mp="1pymxj4pnolxs">
                    {unit.label}
                  </span>
                </div>
                {index < units.length - 1 ? <span className="font-display text-2xl font-bold text-shell/70" data-id="element-36" data-mp="2iiln6m5x9cr1">
                    :
                  </span> : null}
              </React.Fragment>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-37" data-mp="2nefxpbvjmc8a">
            {hours} hours, {minutes} minutes and {seconds} seconds left at the
            launch price.
          </p>

          <p className="mx-auto mt-5 max-w-sm font-sans text-[0.82rem] font-medium leading-snug text-shell" data-id="element-38" data-mp="2ebwwew7eo7o5">
            At midnight the price goes back up — and it will not come back down.
          </p>

          <div className="mt-6 border-t border-shell/25 pt-5" data-id="element-39" data-mp="24mdafhoebxp2">
            <div className="flex items-baseline justify-between gap-4 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-shell/85" data-id="element-40" data-mp="1znsi04fdyib6">
              <span data-id="element-41" data-mp="1vobehgjirv8n">Launch price spots remaining</span>
              <span className="text-lime" data-id="element-42" data-mp="1qnx3pqqja76x">Only a few left</span>
            </div>
            <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-shell/25" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Launch price spots taken" data-id="element-43" data-mp="1loaudsdttb3e">
              <div className="h-full rounded-full bg-lime" style={{
            width: `${spotsTakenPercent}%`
          }} data-id="element-44" data-mp="64tlljcbmvxn" />
            </div>
            <p className="mt-2 text-right font-sans text-[11px] text-shell/85" data-id="element-45" data-mp="b57lge3rqzkl">
              {spotsTakenPercent}% of spots taken
            </p>
          </div>
        </>}
    </div>;
}